import { useEffect, useState } from 'preact/hooks'
import { fetchProductBundles } from 'libs/shopify-product'
import normalizeProducts from 'libs/shopify-normalize'

const useBundleGlobal = () => {
  const [productBundles, setProductBundles] = useState([])
  const [isLoadingBundles, setIsLoadingBundles] = useState(true)

  useEffect(() => {
    const fetchProductBundle = async () => {
      try {
        const products = await fetchProductBundles()
        const normalizeProduct = normalizeProducts(products, 'shopify-graphql-bundles')

        setProductBundles(normalizeProduct)
        setIsLoadingBundles(false)
      } catch (error) {
        console.warn('Error when fetch bundles product', error)
        setIsLoadingBundles(false)
      }
    }

    fetchProductBundle()
  }, [])

  return { productBundles, isLoadingBundles, setIsLoadingBundles }
}

export default useBundleGlobal
